import React from 'react'
import VisibleLeafExplanationContent from '../containers/VisibleLeafExplanationContent'
import VisibleNoExplanations from '../containers/VisibleNoExplanations'
import Box from '../../../core/components/box/Box'
import Text from '../../../core/components/typography/text/Text'
import VisibleRelatedLessons from '../containers/VisibleRelatedLessons'
import {UniLink} from '../../../core/components/unilink/index'
import './leafTopic.css'

const LeafTopic = ({
  isLoggedIn,
  isModerator,
  explanations,
  explanationId,
  activeExplanationIds,
  addActiveExplanation,
  openCreateEditor,
  topicId,
  colorSubject,
  toggleVote,
  history
}) => {
  activeExplanationIds.sort(
    function(x,y){
      //must use == comparator NOT ===
      return x == explanationId ? -1 : y == explanationId ? 1 : 0
    }
  )
  const activeExplanations = []
  for (let i = 0; i < activeExplanationIds.length; i++){
    activeExplanations.push(
      <div className='leaftopic__explanation-container' key={i}>
        <VisibleLeafExplanationContent
          isFirst={i === 0}
          topicId={topicId}
          className='leaftopic__explanation'
          as={`leafExplanation${activeExplanationIds[i]}`} />
      </div>
    )
    if (i === 0) {
      activeExplanations.push(
        // Key can be anythin so long as it's different from others
        <div className='leaftopic__related-lessons' key={-1}>
          <h3 className='leaftopic__section-title leaftopic__related-section-title'>Related Lessons</h3> 
          <VisibleRelatedLessons colorSubject={colorSubject} />
        </div>
      )
    }
  }
  return (
    <div className='leaftopic'>
      { isLoggedIn && isModerator ?
        (<div className='leaftopic__add-explanation-container'>
          <UniLink className='leaftopic__admin-button' 
            to={ '/editor/create/explanation/' + topicId }>
              Create an explanation
          </UniLink>
          <UniLink className='leaftopic__admin-button' id='leaftopic__admin-button-view-v1'
            href={ 'https://v1.expii.com/t/' + topicId }>
              View in V1
          </UniLink>
          <UniLink className='leaftopic__admin-button' id='leaftopic__admin-button-view-problems'
            to={ '/dashboard/' + topicId + '/problems' }>
              View Problems
          </UniLink>
       
        </div> )
        : null
      }
      { explanations && explanations.length ? 
        (
          <div className='leaftopic__explanations'>
            <h2 className='leaftopic__section-title'>
              Explanations ({explanations.length /* total number of explanations */})
            </h2>
            {
              activeExplanations
            }
            <div className='leaftopic__end-of-explanations'>
              <Text color='midGray' fontWeight='medium'>
                You've reached the end
              </Text>
            </div>
          </div>
        )
        : (
          <div>
            <VisibleNoExplanations withColor={colorSubject} />
          </div>
        )
      }
    </div>
  )
}
export default LeafTopic



// WEBPACK FOOTER //
// ./src/domains/topic/components/LeafTopic.js